import { render } from "./CopyLinkDialog.vue?vue&type=template&id=be8f21b2"
import script from "./CopyLinkDialog.vue?vue&type=script&lang=js"
export * from "./CopyLinkDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__